import * as React from 'react';
import { useEffect } from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import type { ProductType } from 'bundles/enterprise-learning-path-description-page/contexts/EventingContext';
import EventingContext from 'bundles/enterprise-learning-path-description-page/contexts/EventingContext';

const EventingDataProvider = ({
  productId,
  productType,
  children,
}: {
  productId: string;
  productType: ProductType;
  children: React.ReactNode;
}) => {
  const track = useTracker();

  useEffect(
    () => {
      track('view_description_page', {
        product: {
          id: productId,
          type: productType,
        },
      });
    }, // FIXME: existing react-hooks/exhaustive-deps violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productId, productType]
  );

  return (
    <EventingContext.Provider
      value={{
        product: {
          id: productId,
          type: productType,
        },
      }}
    >
      {children}
    </EventingContext.Provider>
  );
};

export default EventingDataProvider;
